import styled from "@emotion/styled";
import { theme } from "@product/scmp-sdk";

import { ContentItemPostiesPrimary } from "scmp-app/components/content/content-item-render/variants/posties-primary";
import { Headline as ContentItemPostiesPrimaryHeadline } from "scmp-app/components/content/content-item-render/variants/posties-primary/styles";
import { Headline } from "scmp-app/components/posties/content-homepage/headline";

import BackgroundDesktop from "./background-desktop.jpg";
import BackgroundLargeDesktop from "./background-large-desktop.jpg";
import Background from "./background.jpg";

export const Container = styled.div`
  position: relative;
  z-index: 2;

  background-color: #0f75bf;
  background-image: url(${Background.src});
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: bottom;
  background-size: contain;

  ${theme.breakpoints.up("desktop")} {
    background-image: url(${BackgroundDesktop.src});
  }

  ${theme.breakpoints.up("largeDesktop")} {
    background-image: url(${BackgroundLargeDesktop.src});
    background-size: cover;
  }
`;

export const ContentContainer = styled.div`
  padding-block-end: 65px;

  ${theme.breakpoints.up("desktop")} {
    padding-block-end: 40px;
  }

  ${theme.breakpoints.up("largeDesktop")} {
    padding-block-end: 100px;
  }
`;

export const StyledContentItemPostiesPrimary = styled(ContentItemPostiesPrimary)`
  position: relative;
  z-index: 1;

  ${ContentItemPostiesPrimaryHeadline} {
    color: #ffffff;
  }
`;

export const StyledHeadline = styled(Headline)`
  position: relative;
  z-index: 1;

  margin-block-end: 24px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 56px;
  }
`;
